export default {
  install(Vue) {
    // v-focus
    Vue.directive('focus', {
      inserted(el) {
        el.focus();
      },
    });
  },
};
